import React from 'react';
import { usePagination, useInstantSearch, } from 'react-instantsearch';
export default function Pagination({ paginationComponent: PaginationComponent, paginationSettings, additionalData, }) {
    const pagination = usePagination(paginationSettings);
    const { results } = useInstantSearch();
    const { enableCanonicalUpdates } = paginationSettings;
    if (enableCanonicalUpdates) {
        const { createURL, currentRefinement, isFirstPage, isLastPage, } = pagination;
        let nextLink = document.head.querySelector('link[rel="next"]');
        let prevLink = document.head.querySelector('link[rel="prev"]');
        if (isLastPage && nextLink) {
            nextLink.remove();
        }
        if (isFirstPage && prevLink) {
            prevLink.remove();
        }
        if (!isLastPage) {
            if (!nextLink) {
                nextLink = document.createElement('link');
                nextLink.rel = 'next';
                document.head.appendChild(nextLink);
            }
            nextLink.href = createURL(currentRefinement + 1);
        }
        if (!isFirstPage) {
            if (!prevLink) {
                prevLink = document.createElement('link');
                prevLink.rel = 'prev';
                document.head.appendChild(prevLink);
            }
            prevLink.href = createURL(currentRefinement - 1);
        }
    }
    return (React.createElement(PaginationComponent, { results: results, pagination: pagination, paginationSettings: paginationSettings, additionalData: additionalData }));
}
